import React from 'react';
import './TextArea.css';

const TextArea = ({ 
  label,
  value,
  onChange,
  placeholder,
  required = false,
  error,
  disabled = false,
  id,
  name,
  className = '',
  ...props
}) => {
  const textareaId = id || name || Math.random().toString(36).substr(2, 9);
  
  const classes = [
    'ui-textarea__field',
    error ? 'ui-textarea__field--error' : '',
    disabled ? 'ui-textarea__field--disabled' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className="ui-textarea">
      {label && (
        <label htmlFor={textareaId} className="ui-textarea__label">
          {label}
          {required && <span className="ui-textarea__required">*</span>}
        </label>
      )}
      <div className="ui-textarea__wrapper">
        <textarea
          id={textareaId}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          name={name}
          className={classes}
          {...props}
        />
      </div>
      {error && <span className="ui-textarea__error">{error}</span>}
    </div>
  );
};

export default TextArea; 